import { Button } from "antd";
import Cookies from "js-cookie";
import { Fragment, useState } from "react";
import { User } from "react-feather";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Form, FormGroup, Input } from "reactstrap";

import { adminLogin } from "../../store/adminSlice";

const LoginTabset = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reminder] = useState(localStorage.getItem("loginUser") || false);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    email: localStorage.getItem("loginUser") || "",
    password: "",
  });

  const clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };

  const routeChange = (e) => {
    e.preventDefault();
    setLoading(true);
    dispatch(adminLogin(form))
      .unwrap()
      .then((originalPromiseResult) => {
        Cookies.set("logss", originalPromiseResult.refresh);
        if (reminder) {
          localStorage.setItem("loginUser", form.email);
        }
        toast.success(t("toast.loginSuccess", "Login successful!"));
        navigate("/dashboard", { replace: true });
      })
      .catch((rejectedValueOrSerializedError) => {
        Cookies.remove("logss");
        toast.error(
          rejectedValueOrSerializedError ||
            "Something went wrong, contact admin",
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div>
      <Fragment>
        <Tabs>
          <TabList className="nav nav-tabs tab-coupon">
            <Tab className="nav-link" onClick={(e) => clickActive(e)}>
              <User />
              <span>{t("Login")}</span>
            </Tab>
          </TabList>

          <TabPanel>
            <Form className="form-horizontal auth-form">
              <FormGroup>
                <Input
                  required=""
                  name="login[username]"
                  type="email"
                  className="form-control"
                  placeholder={t("Username", "Username")}
                  id="exampleInputEmail1"
                  value={form.email}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      email: e.target.value,
                    })
                  }
                  autoFocus
                />
              </FormGroup>
              <FormGroup>
                <Input
                  required=""
                  name="login[password]"
                  type="password"
                  className="form-control"
                  placeholder={t("Password", "Password")}
                  value={form.password}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      password: e.target.value,
                    })
                  }
                />
              </FormGroup>
              <div className="form-button mt-3">
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  loading={loading}
                  onClick={(e) => routeChange(e)}
                  style={{ padding: "0 30px", height: "48px" }}
                >
                  {t("Login")}
                </Button>
              </div>
            </Form>
          </TabPanel>
        </Tabs>
      </Fragment>
    </div>
  );
};

export default LoginTabset;
